"use client";

import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import { SidebarMenu, SidebarMenuItem } from "./ui/sidebar";

export function NavUser({ user }) {
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <div className="flex items-center gap-3 p-2 rounded-xl bg-gray-50/70 border border-gray-100">
          <Avatar className="h-8 w-8 rounded-lg border border-gray-200">
            <AvatarImage src={user.avatar} alt={user.name} />
            <AvatarFallback className="rounded-lg bg-purple-100 text-purple-700 font-bold text-xs">
              AD
            </AvatarFallback>
          </Avatar>
          <div className="grid flex-1 text-left leading-tight min-w-0">
            <span className="truncate font-semibold text-gray-900 text-xs">
              {user.name}
            </span>
            <span className="truncate text-gray-400 text-[11px] font-medium">
              {user.email}
            </span>
          </div>
        </div>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
